// extracted by css-extract-rspack-plugin
export default {"container":"IndexParameter-module__container__gQ8UQsE","label":"IndexParameter-module__label__bzFUVrd"};